import type { ModalProps as AntdModalProps } from "antd";
import { Modal as AntdModal } from "antd";
import { FC } from "react";
import { Icon } from "../Icons";
import "./Modal.css";

/**
 * Shared close icon rendered inside Indigo modals.
 * Lives alongside the Modal component so custom headers can reuse it when needed.
 */
export const ModalCloseIcon: FC = () => (
  <span className="indigo-modal-close-icon" aria-hidden="true">
    <Icon name="cross" size="s" />
  </span>
);

export interface ModalProps extends AntdModalProps {
  /**
   * Optional modal title font size in pixels.
   * When provided, wraps the title content and applies this font size.
   */
  titleFontSizePx?: number;
}

/**
 * Thin wrapper around Ant Design's Modal that injects Indigo design tokens
 * (close icon + hover styling) while keeping the same API.
 */
export const Modal: FC<ModalProps> = ({
  closeIcon,
  title,
  titleFontSizePx,
  ...restProps
}) => {
  const resolvedTitle =
    titleFontSizePx !== undefined && title !== undefined ? (
      <span style={{ fontSize: `${titleFontSizePx}px` }}>{title}</span>
    ) : (
      title
    );

  return (
    <AntdModal
      closeIcon={closeIcon ?? <ModalCloseIcon />}
      title={resolvedTitle}
      {...restProps}
    />
  );
};

export default Modal;
